<template>
    <b-modal id="subscription-modal" ref="modal" title="Selecciona una oferta" 
        @ok="handleOk" 
        @cancel="handleCancel"
        :hide-footer="isLoading || true">
        <!-- Modal content goes here -->
        <div v-if="isLoading" class="isLoading">Cargando...</div>

        <template v-else-if="fetchedData.msisdn.status">

            <b-card class="mb-3 bg-ligthgray">
                <b-row align-h="around">
                    <b-col>Número:</b-col>
                    <b-col class="text-right"><b>{{ fetchedData.msisdn.data.subscriber.msisdn }}</b></b-col>
                </b-row>
                <b-row align-h="around">
                    <b-col>ICCID:</b-col>
                    <b-col class="text-right"><b>{{ fetchedData.msisdn.data.subscriber.iccid }}</b></b-col>
                </b-row>
            </b-card>
            <!-- <h6>Número: </h6> -->
            <!-- <h6>ICCID: <b>{{ fetchedData.msisdn.data.subscriber.iccid }}</b></h6> -->

            <template v-if="isIdle || isUnsuscribed">
                <!-- IDLE CREAR-SUSCRIPCION -->
                <!-- isUnsuscribed ACTIVAR-SUSCRIPCION -->
                <SuscriptionPickOffer :msisdn="fetchedData.msisdn.data.subscriber.msisdn" @success="handleSuscriptionSuccess" @fail="$emit('fail')"/>
            </template>

            <template v-else-if="isActive">
                <h6>Paquete <b>{{uiGetUsuariodn.planName}}</b></h6>
                <hr>
                <h4>Activo</h4>
                <b-button block @click="addExtentions">Comprar paquetes extras</b-button>
            </template>

            <template v-else-if="isReactivating">
                <h6>Paquete <b>{{uiGetUsuariodn.planName}}</b></h6>
                <hr>
                <h4>Reactivando...</h4>
                <p class="text-center">
                    Actualiza nuevamente en 10 minutos.
                </p>
                <b-button block @click="refresh()">Actualizar</b-button>
            </template>

            <template v-else-if="isBarring">
                <h6>Paquete <b>{{uiGetUsuariodn.planName}}</b></h6>
                <div>
                    <h4>
                        Actualmente tu línea está en proceso de reactivación.
                        Si tarda mas de 10 min, por favor consulta con BlackFon®;
                    </h4>
                </div>
            </template>

            <template v-else-if="isSuspended">
                <h6>Paquete <b>{{uiGetUsuariodn.planName}}</b></h6>
                <div class="text-danger">
                    <h4>Actualmente tu línea está suspendida</h4>
                </div>
                <b-button variant="warning" block
                    @click="$router.replace({name: 'SuscriptionReactivate'})">Reactivar</b-button>
            </template>

        </template>

        <template v-else>
            <h1 class="text-danger">Número inválido</h1>
        </template>
    </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import { prepareDN } from './suscriptions'
import SuscriptionPickOffer from './SuscriptionPickOffer.vue'
export default {
    name: 'suscriptionHandler',
    components: {
        BModal,
        BButton,
        SuscriptionPickOffer
    },
    computed: {
        isIdle() {
            return (this.msisdnStatus && this.msisdnStatus.toLowerCase() == 'idle');
        },
        isReactivating() {
            return (this.msisdnStatus && !this.isIdle && this.uiGetUsuariodn && this.uiGetUsuariodn.estatus_suscripcion == 'Reactivación');
        },
        isActive() {
            return (this.msisdnStatus && !this.isIdle && !this.isSuspended && this.uiGetUsuariodn && this.uiGetUsuariodn.estatus_suscripcion == 'Activa');
        },
        isSuspended() {
            return (this.msisdnStatus && !this.isBarring && ((this.uiGetUsuariodn && this.uiGetUsuariodn.estatus_suscripcion == 'Suspendido')));
        },
        isBarring() {
            return ((this.msisdnStatus && this.msisdnStatus == 'Barring (B1W)') && ((this.uiGetUsuariodn && this.uiGetUsuariodn.estatus_suscripcion == 'Activa')));
        },
        isUnsuscribed() {
            return (this.msisdnStatus && !this.isIdle && !this.isActive && !this.isSuspended && !this.isReactivating);
        },
        msisdnStatus() {
            return (this.isFound) ? this.fetchedData.msisdn.data.subscriber.status.status : false;
        },
        isFound() {
            try {
                let r = (this.fetchedData.msisdn.status) ? this.fetchedData.msisdn.status : false;
                return r;
            } catch (e) {
                console.warn(e)
            }
            return false;
        }
    },
    props: {
        debug: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            isLoading: true,
            isLoaded: false,
            fetchedData: {},
            item: {
                msisdn: null
            }
        }
    },
    methods: {
        handleSuscriptionSuccess(response){
            console.log('handleSuscriptionSuccess', response)
            this.$refs.modal.hide()
            this.$emit('success', response)
        },
        async loadUp() {
            this.isLoading = true;
            try {
                const response = await prepareDN(this.item.msisdn)
                this.fetchedData = response.data;
                this.isLoaded = true
            } catch (e) {
                this.isLoaded = false
                console.log(e)
            }
            this.isLoading = false;
        },
        showModal(item) {
            this.item = item;
            this.$refs.modal.show()
            this.loadUp()
        },
        handleOk(event) {
            // Handle form submission
            event.preventDefault()
            // Add your submission logic here
        },
        handleCancel() {
            // Handle modal cancel
            this.$refs.modal.hide()
        }
    }
}
</script>

<style scoped>
/* Add any custom styles here */
.bg-ligthgray {
    background-color: var(--lightgray);
}
</style>